// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Pagination, Keyboard, Scrollbar, FreeMode, Manipulation, Autoplay } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
//import 'swiper/css/navigation';
//import 'swiper/css/pagination';
import 'swiper/css/keyboard';
import 'swiper/css/grid';
import 'swiper/css/autoplay';

import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../tailwind.config.js';

const screenSm = parseFloat(resolveConfig(tailwindConfig).theme.screens.sm);
const screenMd = parseFloat(resolveConfig(tailwindConfig).theme.screens.md);
const screenXl = parseFloat(resolveConfig(tailwindConfig).theme.screens.xl);
const screen2xl = parseFloat(resolveConfig(tailwindConfig).theme.screens['2xl']);

const SECTION_ID = 'project-slider';

let projectSwiper = new Swiper(`#${SECTION_ID} .swiper`, {
    modules: [Navigation, Pagination, Keyboard, Autoplay], // configure Swiper to use modules
    speed: 500,
    loop: false,
    slidesPerView: 'auto',
    centeredSlides: false,
    grabCursor: false,
    allowTouchMove: true,

    breakpoints: {
        [screenSm]: {
            allowTouchMove: false,
            centeredSlides: true,
            loop: true,
        },
    },
    keyboard: {
        enabled: true,
    },
    navigation: {
        nextEl: '.arrow-next',
        prevEl: '.arrow-prev',
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
        renderFraction: function (currentClass, totalClass) {
            return '<span class="' + currentClass + '"></span>/<span class="' + totalClass + '"></span>';
        },
    },
});

export { projectSwiper };
